// src/pages/offlineSales/terminal/components/HotkeysModal.jsx
import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import styles from '../OfflineSalesTerminal.module.css';

// Keep in sync with the keydown handlers in OfflineSalesTerminal, ProductGrid,
// PaymentModal and OrderDiscountModal
const HOTKEY_GROUPS = [
  {
    title: 'Terminal',
    keys: [
      { keys: ['F1'], label: 'Cash payment (open payment with Cash selected)' },
      { keys: ['F2'], label: 'Hold order' },
      { keys: ['F3'], label: 'Clear cart' },
      { keys: ['F4'], label: 'Order discount' },
      { keys: ['F5'], label: 'Select customer' },
    ],
  },
  {
    title: 'Product search',
    keys: [
      { keys: ['Enter'], label: 'Add product with exact SKU / barcode match' },
    ],
  },
  {
    title: 'Payment & discount windows',
    keys: [
      { keys: ['0', '–', '9'], label: 'Enter amount' },
      { keys: ['Backspace'], label: 'Delete last digit' },
      { keys: ['Delete'], label: 'Clear amount' },
      { keys: ['Enter'], label: 'Confirm / apply' },
      { keys: ['Esc'], label: 'Close window' },
    ],
  },
];

const HotkeysModal = ({ onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={`${styles.modal} ${styles.hotkeysModal}`} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Keyboard Shortcuts</h3>
          <button onClick={onClose} className={styles.modalClose}><X size={18} /></button>
        </div>

        <div className={styles.hotkeysBody}>
          {HOTKEY_GROUPS.map(group => (
            <div key={group.title} className={styles.hotkeysGroup}>
              <div className={styles.hotkeysGroupTitle}>{group.title}</div>
              {group.keys.map(item => (
                <div key={item.label} className={styles.hotkeysRow}>
                  <span>{item.label}</span>
                  <span className={styles.hotkeysKeys}>
                    {item.keys.map((k, i) => (
                      k === '–'
                        ? <span key={i}>–</span>
                        : <kbd key={i} className={styles.kbdShortcut}>{k}</kbd>
                    ))}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HotkeysModal;
